import { Instance, types } from 'mobx-state-tree'

import { DateFilterModel } from './DateFilterModel'
import { SearchFieldFilterModel } from './SearchFieldFilterModel'
import { SelectFieldFilterModel } from './SelectFieldFilter'

export const FilterModel = types
  .model('FilterModel')
  .props({
    fieldFilters: types.map(types.union(SearchFieldFilterModel, SelectFieldFilterModel, DateFilterModel)),
  })
  .views((self) => ({
    get asUrlSearchParams(): string {
      const urlFilter = Array.from(self.fieldFilters, ([_name, filter]) => filter.getFilterAsUrlParam)
        .filter(Boolean)
        .join('&')
      return urlFilter
    },
  }))

export type SelectFieldFilter = Instance<typeof SelectFieldFilterModel>
export type SearchFieldFilter = Instance<typeof SearchFieldFilterModel>
export type DateFieldFilter = Instance<typeof DateFilterModel>

export type FieldFilter = SearchFieldFilter | SearchFieldFilter | DateFieldFilter
